export default "__VITE_ASSET__BHZ9JGFj__"